"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUploadSchema = void 0;
const react_1 = __importStar(require("react"));
const models_1 = require("app/models");
const parseFile_1 = require("utils/parseFile");
const dayjs_1 = __importDefault(require("dayjs"));
const featureToggles_1 = require("@/utils/featureToggles");
const parseFile_2 = require("@/utils/parseFile");
const firestore_web_1 = require("comodel/firestore-web");
const Form_1 = __importDefault(require("react-bootstrap/Form"));
const react_bootstrap_1 = require("react-bootstrap");
const Button_1 = __importDefault(require("react-bootstrap/Button"));
const google_spreadsheet_1 = require("utils/google-spreadsheet");
const helpers_1 = require("../helpers");
const standard_1 = require("react-hook-schema/standard");
const getUploadSchema = ({ isEditing, projectId, segmentId, langAliases, }) => {
    return {
        schemaType: "object",
        properties: [
            {
                title: "アップロードモードの選択",
                stacked: true,
                propertyName: "uploadMode",
                tooltip: "参照モードは、すでに完了した翻訳を今後の翻訳に利用する場合に使用します。アップロードしたファイルの翻訳作業を進めたい場合は、参照モードではなく、ワークシートモードを選択してください。",
                tooltipVariant: "fixed",
                schema: {
                    schemaType: "radio",
                    options: [
                        { label: "ワークシート", value: "worksheet" },
                        { label: "参照", value: "reference" },
                    ],
                    defaultValue: "worksheet",
                    required: true,
                    horizontal: true,
                },
            },
            Object.assign({ title: "翻訳前ファイル" }, (segmentId
                ? {
                    propertyName: "file",
                    stacked: true,
                    schema: {
                        schemaType: "file",
                        rootPath: `translation_project/${projectId}/segment`,
                        nameFieldPath: "segmentName",
                        fileFieldPath: "rawFile",
                    },
                    tooltip: isEditing
                        ? "翻訳対象となる作業前のファイルです。"
                        : "翻訳対象のファイルをアップロードしてください。",
                    tooltipVariant: "fixed",
                    required: true,
                }
                : {
                    propertyName: "multiFile",
                    stacked: true,
                    schema: {
                        schemaType: "multiFile",
                        rootPath: `translation_project/${projectId}/segment`,
                        filesFieldPath: "rawFiles",
                        fileNameFieldPath: "segmentName",
                        isUniqueFileName: true,
                        fileValidators: [helpers_1.isValidFileSize, helpers_1.isValidRowSize, helpers_1.isXLSXFile],
                        accept: ".xlsx",
                    },
                    tooltip: isEditing
                        ? "翻訳対象となる作業前のファイルです。"
                        : "翻訳対象のファイルをアップロードしてください。",
                    tooltipVariant: "fixed",
                    required: true,
                })),
            ...(!featureToggles_1.featureToggle.importSpreadSheet
                ? []
                : [
                    {
                        title: "翻訳前ファイルインポート",
                        stacked: true,
                        noLabel: true,
                        tooltip: "Google スプレッドシートから翻訳前ファイルをインポートします",
                        propertyId: "translatedFileFromGoogleSheet",
                        schema: {
                            schemaType: "googleImport",
                            nameFieldPath: "segmentName",
                            fileFieldPath: "rawFiles",
                        },
                    },
                ]),
            ...(segmentId
                ? [
                    {
                        title: "翻訳後ファイル",
                        tooltip: "翻訳前ファイルに、翻訳結果を追記したものをダウンロードします",
                        propertyId: "translatedFile",
                        tooltipVariant: "fixed",
                        stacked: true,
                        schema: {
                            schemaType: "message",
                            text: ({ value }) => {
                                return (react_1.default.createElement(react_1.default.Fragment, null,
                                    react_1.default.createElement("a", { onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                                            const workbook = yield composeBook(value.file, projectId, segmentId, {
                                                ignoreLines: value.ignoreLines,
                                                scriptIdFormat: value.scriptIdFormat,
                                                scriptTypeFormat: value.scriptTypeFormat,
                                                translatedScriptFieldFormat: value.translatedScriptFieldFormat,
                                                originalScriptField: value.originalScriptField,
                                                langAliases: langAliases,
                                            });
                                            if (!workbook) {
                                                alert("ファイルの生成に失敗しました");
                                                return;
                                            }
                                            const blob = (0, parseFile_1.bookToBlob)(workbook);
                                            (0, parseFile_1.downloadFile)(blob, `${value.segmentName}-${(0, dayjs_1.default)().format("YYYYMMDDHHmmss")}.xlsx`);
                                        }), href: "#" }, "download")));
                            },
                        },
                    },
                    {
                        title: "翻訳後ファイルエクスポート",
                        tooltip: "翻訳後ファイルをGoogle スプレッドシートに出力します",
                        tooltipVariant: "fixed",
                        stacked: true,
                        propertyId: "translatedFileIntoGoogleSheet",
                        schema: {
                            schemaType: "message",
                            text: ({ value }) => {
                                const useToken = (0, google_spreadsheet_1.useGoogleToken)();
                                const [url, setUrl] = (0, react_1.useState)("");
                                const [progress, setProgress] = (0, react_1.useState)(null);
                                // We need to handle the export task here to dedupe using useEffect's feature.
                                // In case a user cancels sign in first, and later sign in again, the export task will be duplicated
                                // because a then-handler for the access-token promise will be registered twice.
                                // the stale variable in the useEffect hook can handle this case and cancel the first request.
                                const [exportTask, setExportTask] = (0, react_1.useState)(null);
                                (0, react_1.useEffect)(() => {
                                    if (!exportTask)
                                        return;
                                    let stale = false;
                                    (() => __awaiter(void 0, void 0, void 0, function* () {
                                        var _a, e_1, _b, _c;
                                        setProgress({
                                            status: "exporting",
                                            exportedSheets: 0,
                                            totalSheets: 0,
                                        });
                                        const token = yield useToken().catch(() => undefined);
                                        // here, if the task is stale (duplicated or out of react tree), the stale variable will be true
                                        // and results in no-op
                                        if (stale)
                                            return;
                                        if (!token) {
                                            alert("認証失敗");
                                            return;
                                        }
                                        const workbook = yield composeBook(value.file, projectId, segmentId, {
                                            ignoreLines: value.ignoreLines,
                                            scriptIdFormat: value.scriptIdFormat,
                                            scriptTypeFormat: value.scriptTypeFormat,
                                            translatedScriptFieldFormat: value.translatedScriptFieldFormat,
                                            originalScriptField: value.originalScriptField,
                                        });
                                        if (!workbook) {
                                            alert("ファイルの生成に失敗しました");
                                            return;
                                        }
                                        try {
                                            for (var _d = true, _e = __asyncValues((0, google_spreadsheet_1.exportToGoogleSheet)(token, url, workbook)), _f; _f = yield _e.next(), _a = _f.done, !_a; _d = true) {
                                                _c = _f.value;
                                                _d = false;
                                                const signal = _c;
                                                if (signal.type === "progress") {
                                                    setProgress({
                                                        status: "exporting",
                                                        exportedSheets: signal.exportedSheets,
                                                        totalSheets: signal.totalSheets,
                                                    });
                                                }
                                                else if (signal.type === "error") {
                                                    alert(`エラー: ${signal.message}`);
                                                }
                                                else if (signal.type === "succeeded") {
                                                    setProgress({ status: "exported" });
                                                }
                                            }
                                        }
                                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                                        finally {
                                            try {
                                                if (!_d && !_a && (_b = _e.return)) yield _b.call(_e);
                                            }
                                            finally { if (e_1) throw e_1.error; }
                                        }
                                    }))();
                                    return () => {
                                        stale = true;
                                    };
                                }, [exportTask]);
                                return (react_1.default.createElement(react_1.default.Fragment, null,
                                    "\u30B9\u30D7\u30EC\u30C3\u30C9\u30B7\u30FC\u30C8\u306EURL:",
                                    " ",
                                    (progress === null || progress === void 0 ? void 0 : progress.status) === "exported" && react_1.default.createElement(react_1.default.Fragment, null, "\u51FA\u529B\u5B8C\u4E86 "),
                                    (progress === null || progress === void 0 ? void 0 : progress.status) === "exporting" && (react_1.default.createElement(react_1.default.Fragment, null,
                                        "\u51FA\u529B\u4E2D ",
                                        progress.exportedSheets,
                                        "/",
                                        progress.totalSheets)),
                                    react_1.default.createElement("br", null),
                                    react_1.default.createElement(react_bootstrap_1.InputGroup, null,
                                        react_1.default.createElement(Form_1.default.Control, { onChange: (e) => {
                                                setUrl(e.target.value);
                                            }, value: url, type: "url" }),
                                        react_1.default.createElement(Button_1.default, { disabled: url.trim().length === 0 ||
                                                (progress === null || progress === void 0 ? void 0 : progress.status) === "exporting", onClick: () => {
                                                setExportTask({ url });
                                            } }, "\u51FA\u529B"))));
                            },
                        },
                    },
                    {
                        title: "作成日時",
                        stacked: true,
                        style: { marginTop: "2rem" },
                        propertyName: "createdAt",
                        schema: {
                            schemaType: "datetime",
                        },
                        tooltip: "ファイルの優先順位の決定のために必要な情報です。作成日時が後のファイルが参照訳として優先して使用されます。",
                        tooltipVariant: "fixed",
                    },
                ]
                : []),
        ],
    };
};
exports.getUploadSchema = getUploadSchema;
function composeBook(fileName, projectId, segmentId, option) {
    return __awaiter(this, void 0, void 0, function* () {
        const file = yield (0, standard_1.getFile)(fileName);
        if (!file) {
            return null;
        }
        // FIXME: reported by Shōsei Yū <4kizuki@h4dz.io>
        //        What if the file was CSV?
        const workbook = yield (0, parseFile_2.readExcel)(file);
        const accessor = (0, firestore_web_1.queryAccessor)(models_1.scriptDefinition, { projectId, segmentId }, {
            filter: { segmentId },
        });
        const records = yield accessor.get();
        yield (0, parseFile_2.writeTranslation)(workbook, records, option);
        // This code is to "COMMIT" changes. Without this, changed cells are not readable (can not read affected rows)
        return yield (0, parseFile_2.readExcel)((0, parseFile_1.bookToBlob)(workbook));
    });
}
